<script setup lang="ts">
/**
 * 支付模式横幅。
 *
 * 存在的唯一目的：**不许有任何一位顾客或店员误以为这是真的在收钱。**
 * 后端说当前是模拟通道，这里就必须说清楚；读不到后端回答时，
 * 也按「模拟」展示（宁可保守，不可乐观）。
 */
import { computed } from 'vue';
import { kiosk } from '../stores/kiosk';

const props = defineProps<{ offline?: boolean }>();

const simulated = computed(() => kiosk.isSimulated.value);
const reason = computed(() => kiosk.state.paymentConfig?.wechatNotReadyReason ?? null);
</script>

<template>
  <div class="banners">
    <div v-if="props.offline" class="banner banner--danger">
      ⚠️ 连不上点餐机，正在重试 —— 如果一直这样，请叫服务员
    </div>

    <div v-if="simulated" class="banner banner--warn banner--multiline">
      <span class="banner__icon">⚠️</span>
      <span class="banner__text">
        当前是<b>模拟支付（测试）</b>：屏幕上的二维码不会真的收钱，也<b>不计入营业额</b>
        <span v-if="reason" class="banner__reason">（{{ reason }}）</span>
      </span>
    </div>
  </div>
</template>

<style scoped>
.banners {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
}

/* 长句必须能换行：门店的模拟支付提示会带上一整串「缺哪些配置」，
   不换行会被 flex 压成一列一个字（实测过，非常难看） */
.banner--multiline {
  align-items: flex-start;
  flex-wrap: wrap;
  line-height: 1.5;
}

.banner__icon {
  flex: 0 0 auto;
}

.banner__text {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.banner__reason {
  font-weight: 400;
  opacity: 0.85;
}
</style>
